'use strict';

var TNReviewsSlider = (function () {

  var _initialised = {};

  function init(sectionId) {

    if (_initialised[sectionId]) return;
    _initialised[sectionId] = true;

    var wrap    = document.getElementById('tnnursery-reviews-wrap-' + sectionId);
    var track   = document.getElementById('tnnursery-reviews-track-' + sectionId);
    var prevBtn = document.getElementById('tnnursery-reviews-prev-' + sectionId);
    var nextBtn = document.getElementById('tnnursery-reviews-next-' + sectionId);
    var dotsEl  = document.getElementById('tnnursery-reviews-dots-' + sectionId);

    if (!wrap || !track) return;

    var slides      = Array.prototype.slice.call(track.querySelectorAll('.tnnursery-reviews-slide'));
    var totalSlides = slides.length;
    var currentIndex = 0;
    var slideW       = 0;

    // ── drag state ───────────────────────────────────────────────
    var isDragging   = false;
    var dragLocked   = false;   // true = vertical scroll, ignore gesture
    var startX       = 0;
    var startY       = 0;
    var currentX     = 0;
    var baseOffset   = 0;

    // ── helpers ──────────────────────────────────────────────────
    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 768)  return 1;
      if (w <= 1024) return 3;
      return 3;
    }

    function maxIndex() {
      return Math.max(0, totalSlides - getVisibleCount());
    }

    function measureSlide() {
      if (!slides[0]) return;
      var gap = window.innerWidth <= 768 ? 12 : 16;
      slideW  = slides[0].offsetWidth + gap;   // offsetWidth — no stale rect
    }

    function setTrack(px, animate) {
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      track.style.transform = 'translateX(' + (-px) + 'px)';
    }

    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex()));
      baseOffset   = slideW * currentIndex;
      setTrack(baseOffset, true);
      updateDots();
      updateArrows();
    }

    // ── dots ─────────────────────────────────────────────────────
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      var count = maxIndex() + 1;
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.className = 'tnnursery-reviews-dot' + (i === 0 ? ' tnnursery-reviews-dot--active' : '');
        btn.setAttribute('data-index', i);
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (idx) {
          btn.addEventListener('click', function () { goToSlide(idx); });
        }(i));
        dotsEl.appendChild(btn);
      }
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.tnnursery-reviews-dot').forEach(function (dot, i) {
        var active = i === currentIndex;
        dot.classList.toggle('tnnursery-reviews-dot--active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.toggleAttribute('disabled', currentIndex <= 0);
      if (nextBtn) nextBtn.toggleAttribute('disabled', currentIndex >= maxIndex());
    }

    // ── shared drag logic ─────────────────────────────────────────
    function dragStart(x, y) {
      measureSlide();
      isDragging   = true;
      dragLocked   = false;
      startX       = x;
      startY       = y;
      currentX     = x;
      baseOffset   = slideW * currentIndex;
      wrap.style.cursor = 'grabbing';
    }

    function dragMove(x, y, canPrevent, preventDefault) {
      if (!isDragging || dragLocked) return;

      var dx = x - startX;
      var dy = y - startY;

      // axis decision — wait for at least 6px movement
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;

      if (Math.abs(dy) > Math.abs(dx)) {
        dragLocked = true;    // vertical — hand back to browser
        dragEnd(x);
        return;
      }

      // horizontal confirmed — block page scroll
      if (canPrevent) preventDefault();

      currentX = x;
      var offset = baseOffset - dx;
      var min    = 0;
      var max    = slideW * maxIndex();

      // rubber-band resistance at edges
      if (offset < min) offset = min - (min - offset) * 0.25;
      if (offset > max) offset = max + (offset - max) * 0.25;

      setTrack(offset, false);
    }

    function dragEnd(x) {
      if (!isDragging) return;
      isDragging        = false;
      dragLocked        = false;
      wrap.style.cursor = 'grab';

      var dx        = x - startX;
      var threshold = Math.max(40, slideW * 0.2);

      if      (dx < -threshold) goToSlide(currentIndex + 1);
      else if (dx >  threshold) goToSlide(currentIndex - 1);
      else                      goToSlide(currentIndex);      // snap back
    }

    // ── mouse drag ───────────────────────────────────────────────
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      dragStart(e.clientX, e.clientY);
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      dragMove(e.clientX, e.clientY, false, null);
    });

    document.addEventListener('mouseup', function (e) {
      if (!isDragging) return;
      dragEnd(e.clientX);
    });

    document.addEventListener('mouseleave', function () {
      if (!isDragging) return;
      dragEnd(currentX);
    });

    // ── touch drag ────────────────────────────────────────────────
    wrap.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      dragStart(t.clientX, t.clientY);
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      dragMove(t.clientX, t.clientY, true, function () { e.preventDefault(); });
    }, { passive: false });   // non-passive so preventDefault works

    wrap.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      dragEnd(t.clientX);
    }, { passive: true });

    wrap.addEventListener('touchcancel', function (e) {
      var t = e.changedTouches[0];
      dragEnd(t.clientX);
    }, { passive: true });

    // ── prevent click after drag ──────────────────────────────────
    track.querySelectorAll('a, button').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (Math.abs(currentX - startX) > 8) e.preventDefault();
      });
    });

    // ── arrow clicks ──────────────────────────────────────────────
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation(); measureSlide(); goToSlide(currentIndex - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation(); measureSlide(); goToSlide(currentIndex + 1);
    });

    // ── resize ────────────────────────────────────────────────────
    var resizeTimer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        measureSlide();
        goToSlide(0);
        buildDots();
      }, 150);
    });

    // ── init ──────────────────────────────────────────────────────
    wrap.style.cursor = 'grab';
    // Deferred init.
    //
    // measureSlide() reads slides[0].offsetWidth, which forces a synchronous
    // layout. Running it during page load costs a reflow per slider, and on
    // sections using content-visibility: auto it also forces the browser to
    // lay out a subtree it would otherwise have skipped entirely.
    //
    // Nothing here is needed before the slider is near the viewport: at init
    // currentIndex is 0, so the track transform is translateX(0) regardless of
    // the measured width. Arrow clicks and touchstart re-measure on their own.
    function initSlider() {
      measureSlide();
      buildDots();
      updateArrows();
    }

    if ('IntersectionObserver' in window) {
      var initObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        initObserver.disconnect();
        initSlider();
      }, { rootMargin: '300px' });
      initObserver.observe(wrap);
    } else {
      initSlider();
    }
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="tnnursery-reviews-wrap-"]').forEach(function (el) {
    var sectionId = el.id.replace('tnnursery-reviews-wrap-', '');
    TNReviewsSlider.init(sectionId);
  });
});